import React from 'react'

import './Footer.css'

const Footer = () => {
    return (
        <footer className="footer">
            &copy; Birdietime
        </footer>
    )
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js